import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleNavLocked } from '../state/navigationSlice';
import { useMediaQuery } from '../../../_hooks/useMediaQuery';

// Below this width (or on a device with no real hover, i.e. touch) there's
// no room - or no clean gesture - for the rail to reflow open at its full
// width, so it stays a permanently-collapsed icon rail regardless of the
// locked/pinned preference (CSS also hard-forces this below 768px on its
// own - see Navigation.scss).
export const COARSE_OR_NARROW_QUERY = '(hover: none), (max-width: 768px)';

/**
 * Drives MainNav only. Collapsed to an icon rail by default; clicking the
 * chevron toggle straddling the rail's edge (see Navigation.jsx) locks it
 * open and reflows content, or unlocks it back to the icon rail. Purely
 * click-driven - there's no hover-to-peek.
 */
export const useNavigationState = () => {
  const dispatch = useDispatch();
  const { isNavLocked } = useSelector((state) => state.navigation);

  const isCoarseOrNarrow = useMediaQuery(COARSE_OR_NARROW_QUERY);
  const footerRef = useRef(null);

  // A desktop window locked open and then resized/opened narrow (or opened
  // on a touch device) must not carry that open state into the icon-only
  // rail - `isExpanded` (not the raw `isNavLocked`) is what should drive
  // both the rail's width AND the `nav--locked` class (see AppLayout.scss),
  // so it must never be true while the rail itself renders collapsed.
  const isExpanded = isNavLocked && !isCoarseOrNarrow;

  const handleToggleLock = () => {
    dispatch(toggleNavLocked());
  };

  return {
    isExpanded,
    footerRef,
    handlers: {
      handleToggleLock,
    }
  };
};
